import { useGoogleOneTapLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

/**
 * Renders nothing — mounts Google's One Tap prompt (the small account
 * chooser in the corner of the browser) for anonymous visitors. Disabled
 * whenever a user is already signed in, or explicitly via `disabled`
 * (e.g. on /login and /signup, which already have their own Google button).
 */
export default function GoogleOneTapPrompt({ disabled = false }) {
  const { user, googleSignIn } = useAuth();

  useGoogleOneTapLogin({
    disabled: disabled || Boolean(user),
    cancel_on_tap_outside: true,
    use_fedcm_for_prompt: true,
    onSuccess: async (credentialResponse) => {
      const { credential } = credentialResponse;
      if (!credential) {
        console.error('Google One Tap: no credential in response', Object.keys(credentialResponse || {}));
        return;
      }
      const result = await googleSignIn(credential);
      if (!result.ok) {
        console.error('Google One Tap sign-in error:', result.error);
      }
    },
    onError: () => {
      console.error('Google One Tap sign-in failed.');
    },
  });

  return null;
}
